var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmall2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7220_12159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5918 4.52292L4.4918 6.85977H8.6918L9.5918 4.52292L7.7918 5.1545L6.5918 3.25977L5.3918 5.1545L3.5918 4.52292Z",
    fill: "#1F57C3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5918 6.5C12.5918 9.81371 9.90551 12.5 6.5918 12.5C3.27809 12.5 0.591797 9.81371 0.591797 6.5C0.591797 3.18629 3.27809 0.5 6.5918 0.5C9.90551 0.5 12.5918 3.18629 12.5918 6.5ZM11.0911 6.5C11.0911 8.98528 9.07643 11 6.59115 11C4.10586 11 2.09115 8.98528 2.09115 6.5C2.09115 4.01472 4.10586 2 6.59115 2C9.07643 2 11.0911 4.01472 11.0911 6.5Z",
    fill: "#1F57C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5918 7.7002H4.5918V8.9002H8.5918V7.7002Z",
    fill: "#1F57C3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7220_12159"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.591797 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmall2);
export default __webpack_public_path__ + "static/media/small2.0872cd8cbf306607b8e4edd4a55d42b1.svg";
export { ForwardRef as ReactComponent };